import React, { Component } from 'react';

// Elements
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SectionHeading from '../SectionHeading/SectionHeading';

export default class Testimonials extends Component {

    componentDidMount() {
        const carousel = document.createElement("script");
        carousel.src = "js/owl-carousel.customV2.min.js";
        carousel.async = true;
        document.body.appendChild(carousel);
    }

    render() {
        if(this.props.testimonials.length === 0) {
            return <></>;
        }
        return (
        <div className="space-medium bg-light">
            <Container>
                <Row>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <SectionHeading title="What Our Patients Say" as="h1"/>
                    </div>
                </Row>
                <div className="testimonial-carousel">
                    <div className="owl-carousel slider testimonial">
                        {this.props.testimonials.map(review => (
                        <div className="item" key={review.name}>
                            <Col lg={{ span: 8, offset: 2 }} md={{ span: 8, offset: 2 }} sm={12} xs={12}>
                                <div className="testimonial-wrapper">
                                    <div className="testimonial-content">
                                        <div className="testimonial-pic"> <img src={review.avatar} alt={review.name} className="rounded-circle"/></div>
                                        <div className='testimonial-icon text-right'> <img src="img/google_icon.svg" alt="google review"/></div>
                                        <p className="testimonial-text">{review.message}</p>
                                        <div className="rating-value"></div>
                                        <div className="">
                                            <div className="testimonial-meta">
                                                <span>{review.name}</span> </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </div>))}
                    </div>
                </div>
            </Container>
        </div>
        );
    }
}